import { useEffect, useState, useRef } from "react";
import { getElementHeightByClassNameSync } from "../../utils/getElementHeight";
import { resourceLoader } from "../../utils/resourceLoader";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, EffectCoverflow } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import Cookie from "js-cookie";
import axios from "axios";

import "./Gallery.css";

function Gallery(props) {
  const [bgOpacity, setBgOpacity] = useState(0);
  const [picList, setPicList] = useState([
    {
      id: 1,
      url: resourceLoader.getResource("hbg")?.url || "",
      description: "樱花",
      time: "2025.06",
    },
  ]);

  // 移除了 currentBg, currentBgId, currentBgAll 的 useState
  const [currentIndex, setCurrentIndex] = useState(0);
  
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(false);
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [uid, setUid] = useState(null);
  const slideRef = useRef(null);
  const fileInputRef = useRef(null);
  const [uploadDescription, setUploadDescription] = useState("");
  const [uploadTime, setUploadTime] = useState("");
  
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadError, setUploadError] = useState("");
  const [isUploading, setIsUploading] = useState(false);

  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [deleteList, setDeleteList] = useState([]); 
  const [selectedPictures, setSelectedPictures] = useState(new Set()); 
  const [isDeleting, setIsDeleting] = useState(false);

  const BASE_URL = "https://api1.ororigin.xyz";

  // 【核心修复】：通过 picList 和 currentIndex 派生当前显示的信息，保证100%同步
  const defaultPic = {
    id: 0,
    url: resourceLoader.getResource("hbg")?.url || "",
    description: "暂无图片",
    time: "",
  };
  // 确保 currentIndex 不会越界
  const safeIndex = (currentIndex >= 0 && currentIndex < picList.length) ? currentIndex : 0;
  const currentPic = (picList && picList.length > 0) ? picList[safeIndex] : defaultPic;
  
  const currentBg = `url("${currentPic.url}")`;
  const currentBgId = currentPic.id;
  const currentBgAll = currentPic;

  useEffect(() => {
    const userUid = Cookie.get("uid");
    if (userUid) {
      setUid(userUid);
      checkUserLogin(userUid);
    }

    fetchGalleryPictures();
    setBgOpacity(1);
    requestAnimationFrame(() => {
      setIsVisible(true);
    });
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.home-gallery-bottom-btn-more') && 
          !event.target.closest('.gallery-dropdown-menu')) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (uploadModalOpen || deleteModalOpen) {
      props.locker(true);
    }
    if (!(uploadModalOpen || deleteModalOpen)) {
      props.locker(false);
    }
  }, [props, uploadModalOpen, deleteModalOpen]);

  useEffect(() => {
    if (slideRef.current && !slideRef.current.destroyed) {
      // 使用 setTimeout 确保 React 已经把新的 picList 渲染成了真实 DOM
      setTimeout(() => {
        if (slideRef.current && !slideRef.current.destroyed) {
          slideRef.current.update(); // 让 Swiper 重新计算子元素
          slideRef.current.slideToLoop(0, 0); // 以 0 毫秒的动画速度无缝跳转到第一张
          setCurrentIndex(slideRef.current.realIndex || 0); // 确保 React 状态绝对同步
        }
      }, 100);
    }
  }, [picList]);

  const checkUserLogin = async (userUid) => {
    try {
      const response = await axios.get(`${BASE_URL}/api/user/${userUid}`);
      if (response.data.success && response.data.user.is_active) {
        setIsLoggedIn(true);
      } else {
        setIsLoggedIn(false);
      }
    } catch (error) {
      setIsLoggedIn(false);
    }
  };

const fetchGalleryPictures = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/api/gallery`);
      if (response.data.success) {
        const pictures = response.data.pictures;
        setPicList(pictures);
        setCurrentIndex(0);
      }
    } catch (error) {
      console.error("Failed to fetch gallery pictures:", error);
      setCurrentIndex(0);
    }
  };

  const handleSlideChange = (swiper) => {
    const realIndex = swiper.realIndex || 0;
    setCurrentIndex(realIndex);
    // 移除了 updateNormalPicture 函数调用，因为数据已由 React 自动重新派生并渲染
  };

  const handleChangeSlide = (toIndex) => {
    if (picList.length === 0) return;
    if (toIndex < 0) {
      toIndex = picList.length - 1;
    }
    if (toIndex >= picList.length) {
      toIndex = 0;
    }
    if (toIndex == null) return;
    if (slideRef.current) {
      // 因为开了 loop={true}，这里最好使用 slideToLoop 而不是 slideTo
      slideRef.current.slideToLoop(toIndex);
    }
  };

  const handleChangeLoopSlide = (a) => {
    if (picList.length === 0) return;
    if (slideRef.current) {
      if (a) {
        slideRef.current.slidePrev();
      } else {
        slideRef.current.slideNext();
      }
    }
  };

  const handleZoomClick = () => {
    if (picList.length === 0) return;
    setLightboxOpen(true);
  };

  const handleMoreClick = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const handleDeleteClick = () => {
    setDropdownOpen(false);
    setDeleteList(picList);
    setSelectedPictures(new Set());
    setDeleteModalOpen(true);
  };

  const handleSelectPicture = (pictureId) => {
    const newSelected = new Set(selectedPictures);
    if (newSelected.has(pictureId)) {
      newSelected.delete(pictureId);
    } else {
      newSelected.add(pictureId);
    }
    setSelectedPictures(newSelected);
  };

  const handleDeleteSelected = async () => {
    if (selectedPictures.size === 0) {
      alert("请先选择要删除的图片");
      return;
    }

    if (!window.confirm(`确定要删除选中的 ${selectedPictures.size} 张图片吗？`)) {
      return;
    }

    setIsDeleting(true);
    const deletePromises = Array.from(selectedPictures).map(pictureId =>
      axios.delete(`${BASE_URL}/api/gallery/${pictureId}`)
    );

    try {
      const results = await Promise.allSettled(deletePromises);
      let successCount = 0;
      let errorMessages = [];

      results.forEach((result, index) => {
        if (result.status === 'fulfilled' && result.value.data.success) {
          successCount++;
        } else {
          const pictureId = Array.from(selectedPictures)[index];
          errorMessages.push(`图片ID ${pictureId}: ${result.reason?.response?.data?.message || result.reason?.message || '删除失败'}`);
        }
      });

      if (successCount > 0) {
        alert(`成功删除 ${successCount} 张图片`);
        fetchGalleryPictures(); // 重新拉取后会自动触发 currentIndex 归零
      }

      if (errorMessages.length > 0) {
        alert("部分图片删除失败:\n" + errorMessages.join("\n"));
      }

      setDeleteModalOpen(false);
      setSelectedPictures(new Set());
    } catch (error) {
      alert("删除过程中发生错误: " + error.message);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleUploadClick = () => {
    if (!isLoggedIn) {
      window.location.href = "/auth";
      return;
    }
    setUploadModalOpen(true);
    setUploadError("");
    setSelectedFile(null);
    setUploadDescription("");
    setUploadTime("");
  };

  const handleFileSelect = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const maxSize = 6 * 1024 * 1024;
    if (file.size > maxSize) {
      setUploadError("上传图片不能大于6MB");
      setSelectedFile(null);
      event.target.value = ""; 
      return;
    }

    if (!file.type.startsWith("image/")) {
      setUploadError("请选择图片文件");
      setSelectedFile(null);
      event.target.value = "";
      return;
    }

    setSelectedFile(file);
    setUploadError("");
  };

  const handleUploadSubmit = async () => {
    if (!selectedFile) {
      setUploadError("请选择要上传的图片");
      return;
    }
    if (!uploadDescription.trim()) {
      setUploadError("请输入图片描述");
      return;
    }
    if (!uploadTime.trim()) {
      setUploadError("请输入时间");
      return;
    }

    setIsUploading(true);

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("description", uploadDescription);
    formData.append("time", uploadTime);
    let response = null;
    try {
      response = await axios.post(`${BASE_URL}/api/gallery/upload`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      if (response.data.success) {
        fetchGalleryPictures();
        setUploadModalOpen(false);
        setSelectedFile(null);
        setUploadDescription("");
        setUploadTime("");
        setUploadError("");
      } else {
        setUploadError("上传失败: " + response.data.message);
      }
    } catch (error) {
      if ("response" in error) {
        setUploadError(error.response.data.message);
      } else {
        setUploadError("上传错误: " + error.message);
      }
    } finally {
      setIsUploading(false);
    }
  };

  const handleCloseModal = () => {
    setUploadModalOpen(false);
    setSelectedFile(null);
    setUploadDescription("");
    setUploadTime("");
    setUploadError("");
  };

  return (
    <div>
      <div
        className="home-gallery-bg"
        style={{
          backgroundImage: currentBg, 
          opacity: bgOpacity,
        }}
      ></div>
      <div
        className="home-gallery-content"
        style={{
          height: `calc( 100vh - 3rem - 32px )`,
        }}
      >
        <div className="home-gallery-label" style={{transform:isVisible ? "translateX(0px)":"translateX(5vw)"}}>
          <div className="home-gallery-label-info">
            <svg
              data-name="svgicon"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 12.5 13.13"
              className="home-gallery-label-icon"
            >
              <path d="M10,3.14v9H1V3.14h9M11,2.14H0v11h11V2.14h0Z" style={{ fill: "#fff" }} />
              <line x1={8.66} y1={11.09} x2={3.91} y2={6.21} style={{ fill: "none", stroke: "#fff", strokeMiterlimit: 10 }} />
              <polyline points="3.99 11.09 8.69 11.09 8.67 6.39" style={{ fill: "none", stroke: "#fff", strokeMiterlimit: 10 }} />
              <text transform="translate(0 1.29)" style={{ fill: "#fff", fontFamily: "ArialMT, Arial", fontSize: "1.5px" }}>
                <tspan x={0} y={0}>COSMOS-ORIGIN</tspan>
              </text>
            </svg>
            {window.innerHeight <= window.innerWidth ? "Light Chronicles | 时光映画册" : "Light Chronicles"}
          </div>
          {window.innerHeight > window.innerWidth && (
            <div className="home-gallery-label-info b">时光映画册</div>
          )}
        </div>
        <div className="home-gallery-sidefilter l"></div>
        <div className="home-gallery-sidefilter r"></div>
        <div className="home-gallery-container">
          <Swiper
            modules={[Navigation, EffectCoverflow]}
            direction={"horizontal"}
            slidesPerView={3}
            centeredSlides={true}
            className="home-gallery-slides-container"
            spaceBetween={0}
            onSlideChange={handleSlideChange}
            loop={true}
            effect="coverflow"
            onRealIndexChange={handleSlideChange}
            observer={true}
            observeParents={true}
            coverflowEffect={{
              rotate: 15,
              stretch: 0,
              depth: 100,
              modifier: 2.5,
              slideShadows: true,
            }}
            onSwiper={(swiper) => {
              slideRef.current = swiper;
            }}
            breakpoints={{
              0: { slidesPerView: 1, spaceBetween: 10, effect: "slide" },
              768: {
                slidesPerView: 3,
                spaceBetween: 0,
                effect: "coverflow",
                coverflowEffect: { rotate: 15, stretch: 0, depth: 100, modifier: 2.5, slideShadows: false },
              },
            }}
          >
            {picList.map((slide) => (
              <SwiperSlide key={slide.id}>
                <div className="home-gallery-slide">
                  <div className="home-gallery-slide-container">
                    <div
                      className={`home-gallery-slide-pic ${currentBgId == slide.id && "active"}`}
                      style={{ backgroundImage: `url("${slide.url}")` }}
                    >
                      <button className="home-gallery-zoom-button" onClick={handleZoomClick}>
                        <i className="fas fa-search-plus"></i>
                      </button>
                    </div>
                    <div>
                      {/* 同步显示派生信息 */}
                      <div className="home-gallery-time">{currentBgId == slide.id ? currentBgAll?.time : ""}</div>
                      <div className="home-gallery-information">{currentBgId == slide.id ? currentBgAll?.description : ""}</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="home-gallery-line"></div>
        </div>
        <div className="home-gallery-bottom">
          <div className="home-gallery-bottom-btn-container">
            <button className="home-gallery-bottom-btn-more" onClick={handleMoreClick}>
              <i className="fas fa-ellipsis"></i>
            </button>
            
            {dropdownOpen && (
              <div className="gallery-dropdown-menu">
                <button className="gallery-dropdown-item" onClick={handleDeleteClick} disabled={picList.length === 0}>
                  <i className="fas fa-trash-alt"></i> 删除图片
                </button>
              </div>
            )}
            
            <button className="home-gallery-bottom-btn-upload" onClick={handleUploadClick}>
              {isLoggedIn ? "上传图片" : "登录后上传"}
            </button>
          </div>
          <div className="home-gallery-bottom-slidectrl-container">
            <button className="home-gallery-bottom-slidectrl l" onClick={() => handleChangeLoopSlide(true)}>
              <i className="fas fa-angle-left"></i>
            </button>
            <div className="home-gallery-bottom-slidectrl-text">
              {/* 【优化体验】：当没有图片时显示为 0/0，否则显示 x/n */}
              {`${picList.length > 0 ? currentIndex + 1 : 0}/${picList.length}`}
            </div>
            <button className="home-gallery-bottom-slidectrl r" onClick={() => handleChangeLoopSlide(false)}>
              <i className="fas fa-angle-right"></i>
            </button>
          </div>
        </div>
      </div>

      {/* 上传图片模态框 */}
      {uploadModalOpen && (
        <div className="upload-modal-overlay">
          <div className="upload-modal">
             {/* ... 上传模态框代码保持不变 ... */}
             <div className="upload-modal-header">
               <h3>上传图片</h3>
               <button className="upload-modal-close" onClick={handleCloseModal}>
                 <i className="fas fa-times"></i>
               </button>
             </div>
             <div className="upload-modal-body">
               <div className="upload-modal-notice">
                 <i className="fas fa-info-circle"></i>
                 <span>上传图片不能大于6MB</span>
               </div>
               <div className="upload-file-input">
                 <label htmlFor="image-upload" className="upload-file-label">
                   <i className="fas fa-cloud-upload-alt"></i>
                   <span>{selectedFile ? selectedFile.name : "选择图片文件"}</span>
                   <input
                     id="image-upload"
                     type="file"
                     accept="image/*"
                     onChange={handleFileSelect}
                     style={{ display: "none" }}
                   />
                 </label>
               </div>
               {selectedFile && (
                 <div className="file-preview">
                   <div className="file-info">
                     <span>{selectedFile.name}</span>
                     <span className="file-size">
                       {(selectedFile.size / 1024 / 1024).toFixed(2)} MB
                     </span>
                   </div>
                 </div>
               )}
               <div className="upload-form-group">
                 <label htmlFor="description">图片描述</label>
                 <input
                   id="description"
                   type="text"
                   placeholder="请输入图片描述"
                   value={uploadDescription}
                   onChange={(e) => setUploadDescription(e.target.value)}
                 />
               </div>
               <div className="upload-form-group">
                 <label htmlFor="time">时间</label>
                 <input
                   id="time"
                   type="text"
                   placeholder="例如：2025.06"
                   value={uploadTime}
                   onChange={(e) => setUploadTime(e.target.value)}
                 />
               </div>
               {uploadError && (
                 <div className="upload-error">
                   <i className="fas fa-exclamation-triangle"></i>
                   {uploadError}
                 </div>
               )}
             </div>
             <div className="upload-modal-footer">
               <button className="upload-modal-cancel" onClick={handleCloseModal}>
                 取消
               </button>
               <button
                 className="upload-modal-submit"
                 onClick={handleUploadSubmit}
                 disabled={isUploading}
               >
                 {isUploading ? (
                   <>
                     <i className="fas fa-spinner fa-spin"></i>
                     上传中...
                   </>
                 ) : "上传"}
               </button>
             </div>
          </div>
        </div>
      )}

      {/* 删除图片模态框 */}
      {deleteModalOpen && (
        <div className="delete-modal-overlay">
          <div className="delete-modal">
             {/* ... 删除模态框代码保持不变 ... */}
             <div className="delete-modal-header">
               <h3>删除图片</h3>
               <button className="delete-modal-close" onClick={() => setDeleteModalOpen(false)}>
                 <i className="fas fa-times"></i>
               </button>
             </div>
             <div className="delete-modal-body">
               {deleteList.length === 0 ? (
                 <div className="no-pictures">暂无图片可删除</div>
               ) : (
                 <>
                   <div className="delete-modal-notice">
                     <i className="fas fa-info-circle"></i>
                     <span>请选择要删除的图片</span>
                   </div>
                   <div className="delete-pictures-list">
                     {deleteList.map((picture) => (
                       <div
                         key={picture.id}
                         className={`delete-picture-item ${selectedPictures.has(picture.id) ? 'selected' : ''}`}
                         onClick={() => handleSelectPicture(picture.id)}
                       >
                         <div className="delete-picture-checkbox">
                           <i className={`fas fa-${selectedPictures.has(picture.id) ? 'check-square' : 'square'}`}></i>
                         </div>
                         <div className="delete-picture-thumbnail">
                           <img src={picture.url} alt={picture.description} />
                         </div>
                         <div className="delete-picture-info">
                           <div className="delete-picture-description">{picture.description}</div>
                           <div className="delete-picture-time">{picture.time}</div>
                         </div>
                       </div>
                     ))}
                   </div>
                   <div className="delete-selected-count">
                     已选择 {selectedPictures.size} 张图片
                   </div>
                 </>
               )}
             </div>
             <div className="delete-modal-footer">
               <button
                 className="delete-modal-cancel"
                 onClick={() => setDeleteModalOpen(false)}
                 disabled={isDeleting}
               >
                 取消
               </button>
               <button
                 className="delete-modal-confirm"
                 onClick={handleDeleteSelected}
                 disabled={selectedPictures.size === 0 || isDeleting}
               >
                 {isDeleting ? (
                   <>
                     <i className="fas fa-spinner fa-spin"></i>
                     删除中...
                   </>
                 ) : `删除选中的 ${selectedPictures.size} 张图片`}
               </button>
             </div>
          </div>
        </div>
      )}

      <Lightbox
        open={lightboxOpen}
        close={() => setLightboxOpen(false)}
        slides={[
          {
            // 使用新计算出的 currentPic 防止数组越界
            src: currentPic?.url || "",
            alt: currentPic?.description || "图片预览",
          },
        ]}
        controller={{ closeOnBackdropClick: true }}
        carousel={{ finite: true }}
        render={{
          buttonPrev: () => null,
          buttonNext: () => null,
        }}
      />
      <div className="home-scroll-container">
        <p className="home-scroll-text">SCROLL</p>
        <i className="fas fa-angle-down home-scroll-icon"></i>
      </div>
    </div>
  );
}

export default Gallery;